export default "__VITE_ASSET__290a34fe__"